// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4682) return "static/chunks/4682-4a4cd6390f13a176.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"707":"dd56e38849979b74","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};